import { render, staticRenderFns } from "./ProcessCellListItem.vue?vue&type=template&id=60a73262&scoped=true&"
import script from "./ProcessCellListItem.vue?vue&type=script&lang=ts&"
export * from "./ProcessCellListItem.vue?vue&type=script&lang=ts&"
import style0 from "./ProcessCellListItem.vue?vue&type=style&index=0&id=60a73262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a73262",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VImg,VListItem,VListItemAvatar,VListItemContent,VListItemSubtitle,VListItemTitle})
